<style>
.el-tree-node__label {
  font-size: 12px;
}
</style>
<template>
  <div class="check-work-body d-flex">
    <div class="d-flex-left">
      <div class="tree-wrap">
        <div class="project-selector">
          <el-select size="mini" style="width: 100%" v-model="jurisdictionId" filterable placeholder="选择架构"
                     class="kuan" @change="checkedGetList">
            <el-option v-for="item in jurisdictionList" :key="item.id" :label="item.department_name"
                       :value="item.id">
            </el-option>
          </el-select>
          <el-button size="mini" @click="refreshTree" type="success">重置</el-button>
        </div>
        <div class="el-tree-1">
          <el-tree ref="tree" :data="data" :empty-text="emptyText" :props="defaultProps" :lazy="true"
                   :load="getData" @node-click="handleNodeClick"></el-tree>
        </div>
      </div>
    </div>
    <div class="d-flex-right">
      <div>
        <div class="search-wrap">
          <el-button size="mini" @click="addBox" type="primary">添加</el-button>
          <el-button type="warning" @click="importData()" style="color: #FFFFFF">导入</el-button>
          <el-button size="mini" @click="getConfigList" type="primary">查询</el-button>
        </div>
        <!-- 搜索框 -->
        <div style="margin-bottom: 10px;">
          <el-descriptions :column="2" border size="mini">
            <el-descriptions-item label="所选架构" >
              <el-input size="mini" placeholder="" v-model="where.department" disabled></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="姓名">
              <el-input size="mini" placeholder="请输入姓名" v-model="where.name" clearable></el-input>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <!-- 表格 -->
        <div class="table-wrap">
          <el-table v-if="pageData" v-loading="loading" :data="pageData.list">
            <el-table-column prop="project_name" label="项目" align="center" ></el-table-column>
            <el-table-column prop="name" label="姓名" align="center"></el-table-column>
            <el-table-column label="配置类型" align="center" >
              <template slot-scope="scope">
                <span v-if="scope.row.config_type == 1">项目</span>
                <span v-if="scope.row.config_type == 2">个人</span>
              </template>
            </el-table-column>
            <el-table-column prop="rest_days" label="月休天数" align="center" ></el-table-column>
            <el-table-column label="加班费结算类型" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.overtime_type == 1">无</span>
                <span v-if="scope.row.overtime_type == 2">固定1天加班费</span>
                <span v-if="scope.row.overtime_type == 3">应收薪资除以应出勤天数</span>
                <span v-if="scope.row.overtime_type == 4">应收薪资除以30天</span>
              </template>
            </el-table-column>
            <el-table-column prop="overtime_pay" label="固定加班费" align="center"></el-table-column>
            <el-table-column prop="operation" label="操作" width="">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" @click="edit(scope.row)">修改</el-button>
                <el-button type="danger" size="mini" @click="del(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total=pageData.total
                         :page-size="pageData.pageSize * 1" :current-page="pageData.page * 1"
                         @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>
    <!-- 修改窗口 -->
    <el-dialog :title="boxTitle" z-index="990" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px">
      <div style="max-height: 700px;overflow-y: auto;">
        <el-input size="mini" type="hidden" ></el-input>
        <el-descriptions class="margin-top" title="" :column="2" size="mini" border>
          <input type="hidden" v-model="postData.project_id"/>
          <input type="hidden" v-model="postData.xsc_user_id"/>
          <el-descriptions-item label="项目名称">
            <el-input size="mini" readonly class="form-input" v-model="postData.project_name"  autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="员工">
            <el-input size="mini" readonly class="form-input" @focus="selectUser" v-model="postData.name"  autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="配置类型">
            <el-radio-group  v-model="postData.config_type">
              <el-radio :label="1">项目</el-radio>
              <el-radio :label="2">个人</el-radio>
            </el-radio-group>
          </el-descriptions-item>
          <el-descriptions-item label="月休天数">
            <el-input size="mini" v-model="postData.rest_days" class="form-input" autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="加班费结算类型">
            <el-select v-model="postData.overtime_type" size="mini" style="width: 150px">
              <el-option :value="1" label="无" />
              <el-option :value="2" label="固定1天加班费" />
              <el-option :value="3" label="应收薪资除以应出勤天数" />
              <el-option :value="4" label="应收薪资除以30天" />
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="固定加班工资（天）">
            <el-input size="mini" v-model="postData.overtime_pay" class="form-input" autocomplete="off"></el-input>
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">关 闭</el-button>
        <el-button size="mini" @click="save()">确认</el-button>
      </div>
    </el-dialog>
    <selectPersonnel ref="selectPersonnel" />
  </div>
</template>
<script>
import Http from "../common/Http";
import selectPersonnel from "../../Personnel/components/selectPersonnel";

export default {
  name: "SchedulingList",
  components:{selectPersonnel},
  data() {
    return {
      jurisdictionId: '',
      jurisdictionList: [],
      boxTitle : '新增',
      data : [],
      postData: {
        project_id : 0,
        project_name : '',
      },
      emptyText: '没有数据',
      defaultProps: {
        children: '',
        label: 'department_name'
      },
      keyword: '',
      loading: false,
      where: {
        //搜索框
        name: "",
        project_id: "",
      },
      pageData: {
        list: [],
        total: 0,
        page_size: 10,
        page: 1
      },
      dialogVisible: false,
    }
  },
  // 获取列表
  mounted() {
    this.myGetList();
    this.getConfigList();
  },
  methods: {
    // 部门列表
    myGetList(params) {
      Http.get(Http.getFlowBaseURL() + '/hr/department/getHuaRuiDepartmentList', params, res => {
        if (res.code === 0) {
          this.data = res.data;
          this.jurisdictionList = res.data;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          })
        }
      })
    },
    getConfigList() {
      let params = this.where
      params['project_id'] = this.where.project_id
      params['page'] = this.pageData.page
      params['page_size'] = this.pageData.page_size
      Http.get(Http.getPreBaseURL() + "/oa/ProjectConfig/confingList", params, res => {
        if (res.code === 0) {
          this.pageData.list = res.data.data;
          this.pageData.total = res.data.total;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },
    // 单选部门list
    checkedGetList(params) {
      Http.get(Http.getFlowBaseURL() + "/hr/department/getHuaRuiDepartmentList", {
        parent_id: params,
      }, res => {
        if (res.code === 0) {
          this.data = res.data;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },
    // 分页--选中页码
    pageChange(i) {
      this.pageData.page = i;
      this.pageData.page_size = 10;
      this.getPreUserList();
    },
    // 点击树形节点+搜索  = 输出表格
    handleNodeClick(data) {
      this.postData.project_id = data.id
      this.postData.project_name = data.ancestor_name
      this.department_id = data.id
      this.nodeLevel = data.level
      this.where.department = data.ancestor_name
      this.where.project_id = data.id
      this.pageData.page = 1
      this.getConfigList();
    },
    // 刷新右边树
    refreshTree() {
      this.department_id = 0
      this.nodeLevel = 0
      this.where.project_id = 0
      this.pageData.page = 1
      this.myGetList();
      this.jurisdictionId = [];
      this.getConfigList()

    },
    getData(node, resolve) {
      var region_id = node.data.id;//选中节点id
      setTimeout(() => {
        //节点不能为空
        if (region_id == '' || region_id == undefined) {
          return false;
        }
        //加载
        node.data.region_id = region_id;
        node.data && Http.get(Http.getFlowBaseURL() + '/hr/department/getHuaRuiDepartmentList', {parent_id: node.data.id,}, backdata => { // 异步执行成功后
          return resolve(backdata.data);
        });
      }, 300);
    },
    addBox() {
      let projectId = this.postData.project_id
      let projectName = this.postData.project_name
      this.postData = {
          project_id : projectId,
          project_name : projectName,
      }
      if (this.postData.project_id > 0) {
        this.dialogVisible = true
      } else {
        this.$message.error({
          message: '请选择项目！',
          type: "error",
        });
      }
    },
    edit(item) {
      this.postData = item
      this.dialogVisible = true
    },
    del(item) {
      let that = this
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Http.get(Http.getPreBaseURL() + '/oa/ProjectConfig/confingDel', {id:item.id}, backData => {
          if (backData['code'] == 0) {
            this.$message.success({
              message: '修改成功！',
              type: "success",
            });
          }else {
            this.$message.error({
              message: '操作失败！',
              type: "error",
            });
          }
          that.getConfigList()
        })
      });
    },
    save() {
      let that = this
      if (this.postData.id > 0) {
        Http.post(Http.getPreBaseURL() + '/oa/ProjectConfig/confingEdit', this.postData, backData => {
          if (backData['code'] == 0) {
            that.getConfigList()
            this.$message.success({
              message: '修改成功！',
              type: "success",
            });
          }else {
            this.$message.error({
              message: '操作失败！',
              type: "error",
            });
          }
          that.dialogVisible = false
        })
      } else {
        Http.post(Http.getPreBaseURL() + '/oa/ProjectConfig/confingAdd', this.postData, backData => {
          if (backData['code'] == 0) {
            this.$message.success({
              message: '新增成功！',
              type: "success",
            });
          }else {
            this.$message.error({
              message: '操作失败！',
              type: "error",
            });
          }
          that.dialogVisible = false
        })
      }

    },
    selectUser() {
      let that = this
      this.$refs.selectPersonnel.show({}, backData=>{
        that.$set(that.postData, 'xsc_user_id', backData[0]['xsc_user_id'])
        that.$set(that.postData, 'name', backData[0]['username'])
      })
    },
    importData() {
      var that = this;
      let upload = document.getElementById("uploadFile-9999");
      if (!upload) {
        upload = document.createElement('input');
        upload.type = "file";
        upload.id = "uploadFile-9999";
        upload.style.display = "none";
      }
      upload.click();
      upload.onchange = function (e) {

        let formData = new FormData();
        formData.append("user_file", this.files[0]);
        Http.post(Http.getPreBaseURL() + '/oa/ProjectConfig/importConfing', formData, res => {
          that.$message({type: res.code == 0 ? 'success' : 'error', message: res.msg})
        })
        upload.onchange = undefined;
      }
    }
  }
}

</script>
<style lang="scss" scoped>
.el-button--primary,
.el-button--danger,
.el-button--success,
.el-button--warning {
  color: #fff;
}

.el-tree-node__label {
  font-size: 12px;
}

.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
  display: flex;
}

.salary-time-picker {
  margin-left: 10px;
  margin-right: 10px;
  font-size: 20px;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td,
  th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  //flex: 1;
}

.form-input {
  width: 100%;
}

.table-wrap {
  width: calc(100vw - 450px);
  overflow-x: scroll;
  //width: 100%;

}

.amap-box {
  width: 500px;
  height: 500px;
}

.el-tree-1 {

  overflow-y: scroll;
  height: calc(100vh - 120px);
  width: 100%;
}


.fangtai-name {
  font-size: 12px;
}

.tree-wrap {
  width: 250px;
}

.project-selector {
  margin-bottom: 10px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/Scheduling/List.vue